import { useToastStore } from '@/stores/toast.js';

export const useToast = () =>{
  return {
    add(toast = {message, duration, type}) {
      const toastStore = useToastStore();
      toastStore.add(toast);
    }
  }
}
